export enum FareClassOfServiceEnum {
    GroupBooking = "G"
}
